import {ModalInformationAndActionDataInterface} from './modal-information-and-action-component/modal-information-and-action-data.interface';

// export interface CommonModalBaseInterface {
//   templateName: CommonModalTemplatesEnum;
// }

// export class NoneModalData implements CommonModalBaseInterface{
//   public templateName: CommonModalTemplatesEnum = CommonModalTemplatesEnum.NONE;
// }

export enum CommonModalTemplatesEnum {
  // NONE = 'NONE',
  INFO_ADN_ACTION = 'modal-information-and-action',
  STATEMENT = 'statement-modal',
  ASM_EXPIRE = 'asm-expire-modal',
  INFO_AND_CONFIRM = 'modal-confirm',
  CANCEL_ORDER = 'cancel-order-modal',
  CANCEL_SUBSCRIPTION = 'cancel-subscription-modal'
}

export const enum CommonModalStaticEnum {
  COMPLETE_PAIR_CONFIGURATOR_WARNING = 'showmodalwarningcp',
  CANCEL_ORDER_CONFIRMATION = 'cancelorderconfirmation',
  CANCEL_SUBSCRIPTION_CONFIRMATION = 'cancelsubscriptionconfirmation',
  NIP_ERROR = 'nipError',
  ASM_TIMEOUT = 'asmTimeout',
  CONFIRM_POPUP = "confirmPopup"
}

export interface ICommonModalBase {
  templateName: CommonModalTemplatesEnum;
  showCloseBtn?: boolean;
  disableClose?: boolean;
}

export type CommonModalTemplatesInterfaces = ModalInformationAndActionDataInterface;
